import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-3 items-center bg-white shadow pl-3 pr-5 py-5 w-full" }
const _hoisted_2 = { class: "font-medium text-gray-900 capitalize justify-self-center text-center" }
const _hoisted_3 = { class: "relative flex-1 flex flex-col w-full pt-5 pb-4 bg-white" }

import { computed } from "vue"
import { useRoute } from "vue-router"
import GgmsLogo from "@/components/GgmsLogo.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsNavigation from "@/components/GgmsNavigation.vue"
import MenuActionItems from "@/components/MenuActionItems.vue"
import { TransitionChild, TransitionRoot, Dialog } from "@headlessui/vue"
import { MenuIcon, XIcon } from "@heroicons/vue/outline"
import { useNavigationSidebarStore } from "@/stores/navigation-sidebar"
import { NavigationItem } from "@/shared/models/navigation"

interface Props {
    navigation: NavigationItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileSidebarAndheader',
  props: {
    navigation: {}
  },
  emits: ["openPhoneSidebar", "openAddLeadModal", "openNotificationSidebar"],
  setup(__props: any, { emit: __emit }) {

const route = useRoute()

const navigationSidebarStore = useNavigationSidebarStore()

const props = __props

const emit = __emit

const isSidebarOpen = computed(() => navigationSidebarStore.isSidebarOpen)

const pageName = computed(() => {
    // find the page name from the navigation items or from the navigation children items
    let navigationItemName = ""

    for (const item of props.navigation) {
        if (item.path === route.path) {
            navigationItemName = item.name
            break
        }

        const navigationChildItem = item.children?.find((childItem) => childItem.path === route.path)
        if (navigationChildItem) {
            navigationItemName = navigationChildItem.name
            break
        }
    }

    // we have to check separately for the company settings page because it doesn't have a navigation item
    if (navigationItemName === "" && route.path === "/company-settings") {
        navigationItemName = "Company Settings"
    }

    return navigationItemName
})

function toggleSidebar(value: boolean) {
    navigationSidebarStore.toggleSidebar(value)
}

function openPhoneSidebar() {
    emit("openPhoneSidebar")
}

function openAddLeadModal() {
    emit("openAddLeadModal")
}

function openNotificationSidebar() {
    emit("openNotificationSidebar")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GgmsLogo, {
      class: "justify-self-start",
      logoClass: "w-16"
    }),
    _createElementVNode("h1", _hoisted_2, _toDisplayString(pageName.value), 1),
    _createVNode(GgmsButton, {
      styleType: "simple",
      classes: ['py-0 px-0 h-[20px]'],
      class: "justify-self-end",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSidebar(true)))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(MenuIcon), { class: "h-6 w-6" })
      ]),
      _: 1
    }),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: isSidebarOpen.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "fixed inset-0 flex z-40 md:hidden",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (toggleSidebar(false)))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-x-0",
              "leave-to": "translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(GgmsButton, {
                    styleType: "simple",
                    classes: ['py-0 px-0 h-[20px]'],
                    class: "self-end px-4 pb-5",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleSidebar(false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(XIcon), { class: "h-6 w-6" })
                    ]),
                    _: 1
                  }),
                  _createVNode(MenuActionItems, {
                    onOpenPhoneSidebar: openPhoneSidebar,
                    onOpenAddLeadModal: openAddLeadModal,
                    onOpenNotificationSidebar: openNotificationSidebar
                  }),
                  _createVNode(GgmsNavigation, { items: _ctx.navigation }, null, 8, ["items"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})